/* eslint-disable no-case-declarations */
/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useEffect, useState, useCallback, useRef } from "react";
import loadable from "@loadable/component";
import PropTypes from "prop-types";
import Skeleton from "./skeleton";
import { CAR_LIST_EVENT_NAMES, COUNTRY, ORDER_TYPE, FEATURE_FLAG_KEYS, NUMBER, REFERRER_SOURCE, ENABLE_MINIMUM_SPLIT_PAY, SET_DELIVERY_TIMELINE, DELIVERY_TIMELINE_MAPPING, LOAN_PROVIDER, PAGE_SOURCE, WEB_SOURCE, LOCAL_STORAGE_KEYS, AU_RECENTLY_VIEWD_COUNT, LEAD_APPOINTMENT_STATUS, API_SOURCE} from "../../../constants/app-constants";
import { getCheckoutPageURL, getMyBookingCarDetailsURL } from "../../../utils/helpers/get-detail-page-url";
import { CHECKOUT_ROUTE_PATHS, TASKS_ROUTE_PATHS } from "../../../constants/au.desktop/checkout-route-paths";
import { InView, useInView } from "react-intersection-observer";
// import { ORDER_STATUS } from "../../../constants/checkout-constants";
import styles from "./styles.css";
import { trackCustomReMarketingEvents, trackDesktopCustomEventsAU, desktopCleverTapEvent, showSiteControlWidget } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

import MetaTagsCarDetailsV2 from "../../shared/meta-tags-car-details-v2";
import carListingEventDataParser from "../../../tracking/parser/car-listing";
import KelleyBlueBookPopup from "../kelley-blue-book-popup/component";
import PageNotFoundRevamp from "../page-not-found-revamp";
import showFeature from "../../../utils/helpers/show-feaure";
import CarReservationNotifyModal from "../car-reservation-notify-modal";
import { postOrderBookingConfirmed } from "../../../utils/helpers/post-order-placed-confirmed";
import { useLocation } from "react-router-dom";
import qs from "query-string";
// import CarDetailsFaq from "../../shared/car-details-faq";
const CarDetailsFaq = loadable(() => import("../../shared/car-details-faq"), { fallback: <Skeleton /> });
import { getAbExpirementVariant } from "../../../utils/helpers/get-ab-expirement-variant";
import { CMS_SLUG_CONSTANTS, EXPERIMENT_TYPE } from "../../../constants/optimize-constants";
import { CHECKOUT_STEPS, CHECKOUT_STEPS_PATH, FINANCE_TYPE, LOGIN_TYPE, NOT_LOGGED_IN, ORDER_STATUS, VERIFY_LICENCE_STATES } from "../../../constants/checkout-constants";
import TrackImpression from "../../shared/track-impression";
import saveCookie from "../../../utils/helpers/save-cookie";
import { MARKETING_EVENTS_CONSTANTS } from "../../../tracking/marketing-page-events";
import carListingEventDataParserGA4, { parseFilterToDimensionGA4 } from "../../../tracking/parser/car-listing-ga4";
import { clearItem, getItem, setItem } from "../../../utils/helpers/storage-crud";
// import CoachMark from "../coach-mark/component";
import parseCookie from "../../../utils/helpers/parse-cookie";
import CDPBreadCrumb from "../cdp-breadcrumb";
import ErrorHandler from "../../shared/with-error-handler";
import { FB_EVENTS_CATEGORY } from "../../../tracking/fb-events";
import clevertapDetails from "../../../tracking/parser/clevertap-details";
import { CLEVERTAP_EVENT_MAP } from "../../../tracking/au.desktop-clevertap";
import { addToRecentlyViewed } from "../../../utils/helpers/recently-viewed";
import { AU_RECENTLY_VIEWD_KEY } from "../../../constants/app-constants";
// import { modelYearNameGenerator } from "../../../utils/helpers/model-year-name-generator";
import MoreCarsForYouRevamp from "../more-cars-for-you-revamp";
import { LOGIN_SOURCE } from "../../../au-c2b/constants/app-constants";
import useLoginGate from "../../../hooks/use-login-gate";
import CommingSoonThankModal from "../comming-soon-thank-modal";

// REVAMP
import FeatureSpecification from "../cdp-feature-specification";
// import ServiceHistoryRevamp from "../service-history-revamp";
import CarDetailsCardRevamp from "../car-details-card-revamp";
import AboutThisCarRevamp from "../about-this-car-revamp";
import Cars24CarCondition from "../cars24-car-condition";
// import LoanCalculatorRevamp from "../loan-calculator-revamp";
// import CdPFirstFoldBottomBannerRevamp from "../cdp-first-fold-bottom-banner-revamp/";
import CarDetailStickyViewRevamp from "../car-detail-sticky-view-revamp";
import PremiumFeatureRevamp from "../premium-feature-revamp";
import { SITE_CONTROL_EVENTS } from "../../../tracking/site-control-events";
import CarDetailAtfVariantRevamp from "../car-detail-atf-variant-revamp";
// import HappyPurchase from "../happy-purchase/component";
import MoreCarsRevamp from "../more-cars-revamp";
import BuyWithConfidenceRevamp from "../buy-with-confidence";
// import H2 from "../../shared/h2/component";
import { EVENT_CONSTANTS, EVENT_DATA } from "./tracking";
import CdpGoToTop from "../cdp-go-to-top/component";
import isTestDriveEnabledState from "../../../utils/helpers/is-test-drive-enabled-state";
import useShowTradeInCheckoutStep from "../../../hooks/use-show-trade-in-checkout-step";
const PersonaliseYourWishlistModal = loadable(() => import("../../shared/personalise-your-wishlist-modal/component"), { fallback: <Skeleton /> });
import { getPageSectionByName } from "../../../utils/helpers/get-cms-section";
import { PRE_BI_ASSISTANCE_CONFIG } from "../../../config/au.desktop/pre-bi-assistance-config";
import usePreBiAssistance from "../../../hooks/use-pre-bi-assistance";
import { useFireNudge } from "../../../hooks/use-fire-nudge";
import getCookie from "../../../utils/helpers/get-cookie";
import useEwPayload from "../../../hooks/use-ew-payload";
import { useEwVariantConfig } from "../../../hooks/use-ew-variant-config";
import ewSkippedCTEvent, { EW_NOT_ADDED_KEYS, EW_SKIPPED_ENTRY_POINTS } from "../../../utils/helpers/ew-not-added";
import CarPriceGuideCard from "../car-price-guide-card";
import ClassifiedCdpCommentsFromDealer from "../classified-cdp-comments-from-dealer/component";
import OverflowContainer from "../../shared/container-overflow";
import WhyChooseThisCar from "../why-choose-this-car";
import ClassifiedCdpPpsrReportBanner from "../classified-cdp-ppsr-report-banner/component";
import CarServiceHistory from "../car-service-history";
import DealerVerificationInfo from "../dealer-verification-info";
// import ClassifiedCdpPriceHistory from "../classified-cdp-price-history/component";
import ClassifiedCars24QualityPromise from "../classified-cars24-quality-promise/component";
import CdpLoanCalculator from "../cdp-loan-calculator";
import getCarInfo from "../../../utils/helpers/get-car-info";
import { getDealerPage } from "../../../utils/helpers/get-dealer-route";
import LoggedInDealerRedirectModal from "../logged-in-dealer-redirect-modal";
import { GA_EVENTS } from "../login/tracking";
const SellLandingPageCarTrustTopBanner = loadable(() => import("../sell-landing-page-cartrust-top-banner"));
import { useCarHistoryForm } from "../car-history-report-form/hooks/use-car-history-form";
import FeatureSpecificationModal from "../cdp-feature-specification/feature-specification-modal";
import CarPriceGuideCardModal from "../car-price-guide-card-modal";
import CarLocationDetails from "../car-location-card";
import ComingSoonAvailabilityCard from "../../shared/coming-soon-availability-card/component";
import { CDP_CARD_KEYS, DESKTOP_CAR_DETAILS_ORDERING, DESKTOP_CAR_DETAILS_ORDERING_DEALER, PAGE_SECTIONS } from "./constants";
import { getCdpPageSection, parseCdpConfig, calculateCdpCardOrder } from "./helpers";
import { useSortingExperiment } from "../../../hooks/use-sorting-experiment";
// import useOnloadIdle from "../../../hooks/use-onload-idle";
import ListingUspCarousel from "../listing-usp-carousel";
import ListingUspCarouselSkeleton from "../listing-usp-carousel/skeleton";
// import useOnloadIdle from "../../../hooks/use-onload-idle";
import CarFinanceCdpBanner from "../car-finance-cdp-banner";
import { getCarPrice } from "../../../utils/helpers/calculate-egc-dap";
const PriceHistoryReport = loadable(() => import("../price-history-report/component"), { ssr: false, fallback: <Skeleton /> });
export const renderCdpCardByKey = (card, context) => {
    const {key: cardKey, data: cmsData = {}} = card || {};
    switch (cardKey) {
    case CDP_CARD_KEYS.CAR_PRICE_GUIDE:
        return (context?.showKBB) ? (
            <div key={cardKey} styleName={"styles.priceGuideCardLeftSection"}>
                <CarPriceGuideCard
                    priceScale={context?.priceScale}
                    egc={context?.egc}
                    handleCarPriceGuideCardModal={context?.handleCarPriceGuideCardModal}
                    cmsData={cmsData}
                />
            </div>
        ) : null;

    case CDP_CARD_KEYS.WHY_CHOOSE_THIS_CAR:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                <WhyChooseThisCar cmsData={cmsData} isLuxuryCar={context.isLuxuryCar && context.isLuxuryCarVariant} />
            </div>
        );

    case CDP_CARD_KEYS.PRICE_HISTORY_REPORT:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                {context?.content?.carPriceHistory ? (
                    <PriceHistoryReport data={context?.content?.carPriceHistory} />
                ) : null}
            </div>
        );

    case CDP_CARD_KEYS.DEALER_COMMENTS:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                <TrackImpression
                    event={{
                        name: EVENT_DATA.DEALER_COMMENTS_SEEN,
                        data: { ...EVENT_DATA.DEALER_COMMENTS_SEEN, eventLabel: context?.content?.appointmentId || "" }
                    }}
                >
                    <ClassifiedCdpCommentsFromDealer
                        commentsFromDealer={context?.dealerComment || ""}
                        appointmentId={context?.content?.appointmentId || ""}
                        cmsData={cmsData}
                    />
                </TrackImpression>
            </div>
        );

    case CDP_CARD_KEYS.ABOUT_THIS_CAR:
        return (
            <div key={cardKey} styleName={context.aboutThisCarTitleStyle}>
                <AboutThisCarRevamp
                    showDeliveryTimeLine={context.deliveryTimelineVariant}
                    getDeliveryInfoConnect={context.getDeliveryInfoConnect}
                    setDeliveryTimelineConnect={context.setDeliveryTimelineConnect}
                    cmsData={cmsData}
                />
            </div>
        );

    case CDP_CARD_KEYS.PREMIUM_FEATURES:
        return (
            <div key={cardKey} ref={context.premiumFeaturesRef} styleName={"styles.keyHighlight"}>
                <TrackImpression event={{}}>
                    <PremiumFeatureRevamp cmsData={cmsData} />
                </TrackImpression>
            </div>
        );

    case CDP_CARD_KEYS.FEATURES_SPECS:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"} ref={context.featuresAndSpecsRef}>
                <TrackImpression event={{}}>
                    <FeatureSpecification handleFeatureSpecsModal={context.handleFeatureSpecsModal} cmsData={cmsData} />
                </TrackImpression>
            </div>
        );

    case CDP_CARD_KEYS.BUY_WITH_CONFIDENCE:
        const cmsContent = getPageSectionByName(context?.cmsConfig?.data?.pageSections, CMS_SLUG_CONSTANTS.CARS24_EDGE_DETAILS);
        const content = cmsContent?.meta || {};
        const currentContent = context.isLuxuryCar && context.isLuxuryCarVariant ? content?.LUXURY : content?.PRIME;
        return (
            <div key={cardKey} styleName={"styles.cdpBuyWithConfidenceWrapper"}>
                <p styleName={"styles.buyWithConfidenceHeading"}>{currentContent?.heading}</p>
                <OverflowContainer>
                    <BuyWithConfidenceRevamp
                        cdpPage={true}
                        source={PAGE_SOURCE.CDP.toUpperCase()}
                        showHeader={false}
                        buyWithConfidence={context.buyWithConfidence || []}
                        config={context.config}
                        isLuxuryCar={context.isLuxuryCar && context.isLuxuryCarVariant}
                        cmsConfig={context.cmsConfig}
                        cmsData={cmsData}
                    />
                </OverflowContainer>
            </div>
        );

    case CDP_CARD_KEYS.PPSR_REPORT: {
        const ppsrStatus = context?.content?.ppsrReportLink ? "generated" : "generation_in_progress";
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                <TrackImpression
                    event={{
                        name: EVENT_DATA.PPSR_REPORT_BANNER_SEEN,
                        data: { ...EVENT_DATA.PPSR_REPORT_BANNER_SEEN, eventLabel: ppsrStatus }
                    }}
                >
                    <ClassifiedCdpPpsrReportBanner content={context.content} cmsData={cmsData} />
                </TrackImpression>
            </div>
        );
    }

    case CDP_CARD_KEYS.CAR_HISTORY_BANNER:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                <SellLandingPageCarTrustTopBanner
                    pageSource={PAGE_SOURCE.CDP}
                    pageSection={context.chrMediumBannerSection}
                    cmsData={cmsData}
                />
            </div>
        );
    case CDP_CARD_KEYS.FINANCE_CARD:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                <CarFinanceCdpBanner
                    pageSection={context.financeCardSection}
                />
            </div>
        );

    case CDP_CARD_KEYS.SERVICE_HISTORY: {
        const serviceHistoryStatus = (context?.content?.serviceHistory || []).length > 0 ? "generated" : "generation_in_progress";
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"} ref={context.carhistoryRef}>
                <TrackImpression
                    event={{
                        name: EVENT_DATA.SERVICE_HISTORY_SEEN,
                        data: { ...EVENT_DATA.SERVICE_HISTORY_SEEN, eventLabel: serviceHistoryStatus }
                    }}
                >
                    <CarServiceHistory carhistoryRef={context.carhistoryRef} cmsData={cmsData} />
                </TrackImpression>
            </div>
        );
    }

    case CDP_CARD_KEYS.DEALER_VERIFICATION:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                <TrackImpression
                    event={{
                        name: EVENT_DATA.DEALER_PROFILE_SEEN,
                        data: { ...EVENT_DATA.DEALER_PROFILE_SEEN, eventLabel: context?.content?.appointmentId || "" }
                    }}
                >
                    <DealerVerificationInfo handleShowLoggedInDealerRedirect={context.handleShowLoggedInDealerRedirect} cmsData={cmsData} />
                </TrackImpression>
            </div>
        );

    case CDP_CARD_KEYS.LOAN_CALCULATOR:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"} ref={context.calculatorRef}>
                <CdpLoanCalculator calculatorRef={context.calculatorRef} cmsData={cmsData} />
            </div>
        );

    case CDP_CARD_KEYS.QUALITY_PROMISE:
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                <ClassifiedCars24QualityPromise cmsData={cmsData} isLuxuryCar={context.isLuxuryCar && context.isLuxuryCarVariant} cmsConfig={context.cmsConfig} />
            </div>
        );

    case CDP_CARD_KEYS.CAR_CONDITION:
        return (
            <div key={cardKey} ref={context.qualityPromiseRef} styleName={"styles.keyHighlight"}>
                <TrackImpression
                    handleImpressionView={() => context.handleImpressionView("inspection")}
                    event={{amplitudeName: EVENT_CONSTANTS.IMPERFECTION_SEEN}}
                >
                    <Cars24CarCondition cmsData={cmsData} />
                </TrackImpression>
            </div>
        );

    case CDP_CARD_KEYS.LUXURY_CAR_CAROUSEL:
        if (!context?.isLuxuryCar) {
            return null;
        }
        if (!context?.isLuxuryCarVariant) {
            return null;
        }
        if (!context.cmsConfig) {
            return (
                <div key={cardKey} styleName={"styles.keyHighlight"}>
                    <ListingUspCarouselSkeleton />
                </div>
            );
        }
        return (
            <div key={cardKey} styleName={"styles.keyHighlight"}>
                <ListingUspCarousel cmsConfig={context.cmsConfig}/>
            </div>
        );

    default:
        return null;
    }
};

const CarDetailsRevamp = ({
    match: {
        params: { lid: carId }
    },
    carDetails,
    fetchCarDetailsConnect,
    updateCarDetailsSSRStatusConnect,
    setGsGalleryDataConnect,
    history,
    fetchSimilarCarsConnect,
    getDeliveryInfoConnect,
    setOnLoginSuccessCallback,
    openLoginPopupConnect,
    orderStatus,
    isLoggedIn,
    onClickAddToWishList,
    secureToken,
    orderId,
    isWishlistedCar,
    getOrderDetailConnect,
    fetchConfigConnect,
    // showFullScreenGallery = {},
    saleConfig = {},
    updateLoginFetchCarDetailCompletedConnect,
    fetchEgcPriceConnect,
    createOrderConnect,
    updateOrderConnect,
    getCheckoutStepsConnect,
    getTradeInToggleVisibleConnect,
    tradeInToggleSelected,
    getWarrantyPlansConnect,
    // showPreApprovalCoachmark,
    setPreApprovalCoachMarkDisplayConnect,
    showUserDeliveryTimeline,
    setDeliveryTimelineConnect,
    financeProvider,
    email,
    allFilters,
    appliedFilters,
    selectedSort,
    listingType,
    isUserZeroDpVariant,
    showCdpGalleryVariant,
    hideSiteHeader = false,
    testDriveStatus,
    setLoginTypeConnect,
    getIsStraightThroughEligbleConnect,
    getInterestRateForPriceCalculatorConnect,
    userGeoData,
    // showTestDriveLocation
    updateValidC2bOrderConnect,
    getTradeInDetailsConnect,
    drivingLicenceStatus,
    testDriveConfig,
    fetchCmsConfigConnect,
    updateWishlistNoteConnect,
    showPrioritizationModalConnect,
    showPersonaliseYourWishlistModal,
    desktopWishlistAdoption,
    categoryNudgeCounts,
    updateSupportWidgetConfigConnect,
    updateNudgeCountsConnect,
    updateNotificationCountsConnect,
    setNudgeTimerIdConnect,
    nudgeCountSynced,
    servicingPriceConfig,
    desktopCdpEw,
    desktopPremiumFeatures,
    setCarSeenCountConnect,
    paymentSummaryData,
    fullName,
    mobile: userMobile,
    updateBasicHubspotConnect,
    firstName,
    lastName,
    userEmail,
    webCarTour,
    // phoneNumberVerified — replaced by isLoggedIn for dealer contact flow
    orderCustomerPhoneNumber,
    cdpCtaReorder,
    fetchLeadAppointmentConnect,
    createClassifiedLeadConnect,
    dealerInfo,
    dealerSSR,
    getDealerInfoConnect,
    reloadCarDetailsConnect,
    desktopLuxuryCars,
    hideImperfectionsDesktop,
    desktopComingSoon,
    rootCmsConfig,
    desktopVehicleBasePrice
}) => {

    const { content, isSSR, isFetching, config, error, ipDetectedState = "", isLoginFetchCarDetailCompleted = false, similarCars, isExtendedWarrantySelected = false, cmsConfig, shouldReloadCarDetails } = carDetails;
    const {isDealerListing, isInternalListing, dealerCode, dealerComment, isLuxuryCar} = getCarInfo(content);
    const { appointmentId,
        booked,
        year,
        // modelYear,
        make,
        model,
        comingSoon,
        egc = 0,
        kbbAskingPriceRangeMin = 0,
        kbbAskingPriceRangeMax = 0,
        vehicleRetailPriceRangeMin = 0,
        vehicleRetailPriceRangeMax = 0,
        listingActive,
        // emiDetails,
        personalised,
        // serviceHistory = [],
        reserved,
        kbbValueProvidedOn,
        kbbAskingPrice,
        vehicleRetailPrice,
        city, state,
        similarModelCars = [],
        buyWithConfidence,
        ewDetails,
        category = null,
        carTourPresent,
        priceScale
    } = content || {};
    const vehcileAskingPriceRangeMax = vehicleRetailPriceRangeMax || kbbAskingPriceRangeMax || 0;
    const vehcileAskingPriceRangeMin = vehicleRetailPriceRangeMin || kbbAskingPriceRangeMin || 0;
    const vehicleAskingPrice = vehicleRetailPrice || kbbAskingPrice || 0;

    const showKBB = isDealerListing
        ? true
        : (egc && vehcileAskingPriceRangeMin >= 0 && vehcileAskingPriceRangeMax && egc < vehicleAskingPrice);
    const { state: { name: userState = {} } = {} } = userGeoData || {};
    const [carReservationModalOpen, setCarReservationModal] = useState(false);
    const [notifyIconCliked, setNotifyIconClicked] = useState(false);
    const [wishlistActionCompleted, setWishlistActionCompleted] = useState(false);
    const [isStickyHeaderVisible, setIsStickyHeaderVisible] = useState(false);
    const [isFeatureSpecsModalOpen, setIsFeatureSpecsModalOpen] = useState(false);
    const [isCarPriceGuideCardModalOpen, setIsCarPriceGuideCardModalOpen] = useState(false);
    const [showKbbModal, setShowKbbModal] = useState({ detail: false, approach: false });
    const [showLoggedInDealerRedirectModal, setShowLoggedInDealerRedirectModal] = useState(false);
    const [dealerRedirectRoute, setDealerRedirectRoute] = useState("");
    const [classifiedModalSource, setClassifiedModalSource] = useState("");
    const [showComingSoonThank, setShowComingSoonThank] = useState(false);
    const pendingActionRef = useRef(null);
    const loginGate = useLoginGate({
        requiredFields: ["profileName", "email", "mobile"],
        closableModal: true,
        onComplete: () => {
            const action = pendingActionRef.current;
            pendingActionRef.current = null;
            if (action) action();
        }
    });

    const runComingSoonEnquiry = async () => {
        try {
            let activeOrderId = orderId;
            if (!activeOrderId) {
                const orderPayload = {
                    appointmentId: appointmentId || carId,
                    vehiclePrice: getCarPrice({
                        egcPrice: content?.egc,
                        dapPrice: content?.price
                    }).egc.value,
                    orderType: ORDER_TYPE.BUY_ONLINE
                };
                const orderResponse = await createOrderConnect(orderPayload);
                activeOrderId = orderResponse?.orderId;
            }
            if (activeOrderId && updateBasicHubspotConnect) {
                await updateBasicHubspotConnect(activeOrderId, {
                    deliveryAddress: {
                        customerName: fullName,
                        customerPhoneNumber: userMobile
                    },
                    pickUpAddress: {
                        customerName: fullName,
                        customerPhoneNumber: userMobile
                    }
                });
            }
        } catch (err) {
            // best-effort
        }
        setShowComingSoonThank(true);
    };

    const comingSoonGate = useLoginGate({
        requiredFields: ["email", "mobile"],
        incompleteProfileAction: "secondaryIdentifier",
        onComplete: () => runComingSoonEnquiry()
    });

    const [isResumeVisible, setIsResumeVisible] = useState(false);
    const [isFetchingOrderDetails, setIsFetchingOrderDetails] = useState(false);
    const [step, setStep] = useState(null);
    const { showTradeInCheckoutStep } = useShowTradeInCheckoutStep();
    const calculatorRef = useRef(null);
    const [showCta, setShowCta] = useState(false);
    const setShowCtaHandler = (inView) => {
        setShowCta(inView);
    };
    const { sortingVariant, currentStateCode } = useSortingExperiment({source: API_SOURCE.WEB_APP});
    // const isIdleLoaded = useOnloadIdle();
    // const [isLoading, setLoading] = useState(false);
    // const modelYearName = modelYearNameGenerator(modelYear);
    // const carFullName = `${year || ""} ${make || ""} ${model || ""} ${modelYearName}`;
    const isGalleryView = (useLocation().pathname.indexOf("gallery")) > 0;
    const query = (useLocation().search || "").toString();
    const { data: showCdpGalleryVariantData } = showCdpGalleryVariant || {};

    const { data: showDeliveryTimelineData } = showUserDeliveryTimeline || {};
    const deliveryTimelineVariant = showDeliveryTimelineData === EXPERIMENT_TYPE.VARIANT_B;
    const enableNewPostBook = (financeProvider === LOAN_PROVIDER.NONE || financeProvider === LOAN_PROVIDER.BYOF) && (drivingLicenceStatus === VERIFY_LICENCE_STATES.UPLOAD_PENDING);
    const filterDimensionsGA4 = parseFilterToDimensionGA4(allFilters, appliedFilters, selectedSort);

    const showS20GalleryVariant = showCdpGalleryVariantData === EXPERIMENT_TYPE.VARIANT_B;
    const { data: testDriveVariant } = "VARIANT_B";
    const { data: customStateVariant } = {};
    const { ewRequestPayload, ewRequestBody } = useEwPayload();
    const { eligibleStateNames = [] } = testDriveConfig?.data || {};

    const {data: cmsConfigData = {}} = cmsConfig || {};
    const {pageSections = []} = cmsConfigData || {};
    // todo:deepak add meta to wishlist globally and use a single helper
    const personalizationSectionData = getPageSectionByName(pageSections, PAGE_SECTIONS.WISHLIST_PERSONALISATION_MODAL);
    const faqSectionData = getPageSectionByName(pageSections, PAGE_SECTIONS.CDP_FAQ)?.sectionData || [];
    const faqDealerSectionData = getPageSectionByName(pageSections, PAGE_SECTIONS.CDP_DEALER_FAQ)?.sectionData || [];
    const faqData = isDealerListing ? faqDealerSectionData : faqSectionData;
    const {getPageSectionFromName} = useCarHistoryForm();
    const chrMediumBannerSection = getPageSectionFromName({sectionName: PAGE_SECTIONS.CAR_TRUST_MEDIUM_BANNER, cmsContent: cmsConfig?.data}) || null;
    const financeCardSection = getPageSectionFromName({sectionName: PAGE_SECTIONS.CAR_FINANCE_BANNER, cmsContent: cmsConfig?.data}) || null;
    const { showEwVariantA, showEwVariantB, showEwVariantF } = useEwVariantConfig(desktopCdpEw, paymentSummaryData, ewDetails);
    const getEwStickyTopClass = () => {
        if (showEwVariantB) return "styles.ewVariantBStickyTop";
        if (showEwVariantF) return "styles.ewVariantFStickyTop";
        return "";
    };
    const ewStickyTopClass = getEwStickyTopClass();
    const isWebCarTourVariant = getAbExpirementVariant(webCarTour, EXPERIMENT_TYPE.VARIANT_B);
    const isLuxuryCarVariant = getAbExpirementVariant(desktopLuxuryCars, EXPERIMENT_TYPE.VARIANT_B);
    const handleFeatureSpecsModal = () => {
        setIsFeatureSpecsModalOpen(!isFeatureSpecsModalOpen);
    };
    const handleCarPriceGuideCardModal = () => {
        setIsCarPriceGuideCardModalOpen(!isCarPriceGuideCardModalOpen);
    };

    const isCdpCtaReorderVariant = getAbExpirementVariant(cdpCtaReorder, EXPERIMENT_TYPE.VARIANT_B);
    useEffect(() => {
        if (!dealerSSR && isDealerListing) {
            getDealerInfoConnect({dealerId: dealerCode});
        }
    }, [dealerCode, dealerSSR, getDealerInfoConnect, isDealerListing]);

    useEffect(() => {
        if (!isSSR) {
            fetchCmsConfigConnect({
                slug: isDealerListing ? CMS_SLUG_CONSTANTS.CAR_DETAILS_DESKTOP_DEALER : CMS_SLUG_CONSTANTS.CAR_DETAILS_DESKTOP,
                pincode: userGeoData?.postalCode,
                appointmentId: carId
            });
        }
        if (!isDealerListing) {
            trackDesktopCustomEventsAU("Imperfection Experiment", {
                event: "experiment",
                eventCategory: "Imperfection Experiment",
                eventAction: "variant_assigned",
                eventLabel: hideImperfectionsDesktop?.data
            });
        }
        trackDesktopCustomEventsAU("wishlist", {
            event: "experiment",
            eventCategory: "wishlist",
            eventAction: "variant_assigned",
            eventLabel: desktopWishlistAdoption?.data
        });
        trackDesktopCustomEventsAU("vehicle_base_price", {
            event: "experiment",
            eventCategory: "vehicle_base_price",
            eventAction: "variant_assigned",
            eventLabel: desktopVehicleBasePrice?.data || "null"
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.TEST_DRIVE_LOCATION_EXPOSURE, {
            eventAction: AU_DESKTOP_EVENTS.TEST_DRIVE_LOCATION_EXPOSURE,
            eventLabel: testDriveVariant,
            eventCategory: "Cars24_detail_page"
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CDP_CTA_REORDER, {
            eventAction: "variant_assigned",
            event: "custom_event",
            eventLabel: cdpCtaReorder?.data || "no variant",
            eventCategory: "CDP_CTA_optimisation"
        });
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.WEB_CUSTOM_STATE_EXPERIMENT, {
            eventAction: AU_DESKTOP_EVENTS.WEB_CUSTOM_STATE_EXPERIMENT,
            eventLabel: `${customStateVariant}_${JSON.stringify(userGeoData)}`,
            eventCategory: "Cars24_detail_page"
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR, content]);

    useEffect(() => {
        // eslint-disable-next-line no-nested-ternary
        const userId = personalised ? "PRE_APPROVED" : isLoggedIn ? "NOT_PRE_APPROVED" : "NOT_LOGGED_IN";
        if (appointmentId && !personalised) {
            const params = {
                appointmentId,
                userId,
                year,
                ...egc >= 0 && { price: +egc },
                creditScore: "EXCELLENT"
            };
            getInterestRateForPriceCalculatorConnect(params);
        }
    }, [appointmentId, personalised, year, getInterestRateForPriceCalculatorConnect, isLoggedIn, egc]);
    useEffect(() => {
        const queryParams = qs.parse(query);
        // eslint-disable-next-line camelcase
        const { referrer_source = "origin", enableMinimumPay } = queryParams || {};
        saveCookie(REFERRER_SOURCE, referrer_source);
        if ("enableMinimumPay" in queryParams) {
            saveCookie(ENABLE_MINIMUM_SPLIT_PAY, enableMinimumPay, NUMBER.THREE);
        }
        const showTdfViaQuery = (queryParams || {}).tdf === "true";//tdf => testdriveflow
        const testDriveViaFeatureFlag = showFeature(FEATURE_FLAG_KEYS.TEST_DRIVE_FLAG, NUMBER.FIFTY);
        if (showTdfViaQuery) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventAction: "variant_with_test_drive",
                eventLabel: "NA"
            });
        } else if (!testDriveViaFeatureFlag) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventAction: "variant_without_test_drive",
                eventLabel: "NA"
            });
        } else if (testDriveViaFeatureFlag) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventAction: "variant_with_test_drive",
                eventLabel: "NA"
            });
        }
    }, [query]);

    useEffect(() => {
        if (showCdpGalleryVariantData === EXPERIMENT_TYPE.VARIANT_A) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.S20_VIEWER_AND_GALLERY, {
                eventLabel: "VARIANT_A"
            });
        } else if (showCdpGalleryVariantData === EXPERIMENT_TYPE.VARIANT_B) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.S20_VIEWER_AND_GALLERY, {
                eventLabel: "VARIANT_B"
            });
        }
    }, [showCdpGalleryVariantData]);

    useEffect(() => {
        if (showDeliveryTimelineData === EXPERIMENT_TYPE.VARIANT_A) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CDP_DELIVERY_TIMELINE, {
                eventAction: "cdp_delivery_timeline",
                eventLabel: "VARIANT_A"
            });
        } else if (showDeliveryTimelineData === EXPERIMENT_TYPE.VARIANT_B) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CDP_DELIVERY_TIMELINE, {
                eventAction: "cdp_delivery_timeline",
                eventLabel: "VARIANT_B"
            });
        }
    }, [showDeliveryTimelineData]);

    useEffect(() => {
        if ((saleConfig && saleConfig.data && Object.keys(saleConfig.data).length === 0) || carId !== appointmentId) {
            fetchConfigConnect();
        }
        // clearing the 500 minimum key from storage for every BI
        clearItem(ENABLE_MINIMUM_SPLIT_PAY);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fetchConfigConnect]);

    useEffect(() => {
        // if (isVariant) {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_AB, { eventLabel: "full_view" });
        // } else {
        //     trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_AB, {eventLabel: "normal_view"});
        // }
        if (appointmentId && appointmentId === carId) {
            fetchEgcPriceConnect(appointmentId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId, fetchEgcPriceConnect, tradeInToggleSelected]);

    useEffect(() => {
        if (ipDetectedState) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LOCATION_STATE_DETAIL, { eventLabel: ipDetectedState });

        }
        const userStateValue = parseCookie(SET_DELIVERY_TIMELINE) || ipDetectedState;
        setDeliveryTimelineConnect(DELIVERY_TIMELINE_MAPPING[userStateValue] || {});
    }, [ipDetectedState, setDeliveryTimelineConnect]);

    useEffect(() => {
        if (appointmentId && appointmentId === carId && !isGalleryView) {
            const data = carListingEventDataParser(content, {
                list: CAR_LIST_EVENT_NAMES.DETAILS,
                excludedKeys: [
                    "list"
                ]
            });
            const dataGA4 = carListingEventDataParserGA4(content, {
                filterDimensions: filterDimensionsGA4,
                listingType
            });
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS, {
                ...data.carDetails,
                platform: WEB_SOURCE.desktop
            });
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_LOCATION, { eventLabel: `${appointmentId}_${city}` });
            trackDesktopCustomEventsAU("clearEccomerce", { ecommerce: null });
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.VIEW_ITEM, {
                user_id: email,
                ...dataGA4,
                platform: WEB_SOURCE.desktop
            });

            //cleverTap
            const detailsData = clevertapDetails(content, { prefix: "viewed_", config, withCarAttributes: true });
            desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.CAR_DETAIL_PAGE_VIEWED, detailsData);

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId, carId, isGalleryView]);

    useEffect(() => {
        if (appointmentId) {
            if (isGalleryView) {
                const queryParams = qs.parse(query);
                const { selectedImageIndex = 0, activeTab = "exterior" } = queryParams;
                setGsGalleryDataConnect({
                    isOpen: true,
                    activeTab,
                    selectedImageIndex: parseInt(selectedImageIndex)
                });
            } else {
                setGsGalleryDataConnect({
                    isOpen: false
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isGalleryView, appointmentId]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [carId, setGsGalleryDataConnect]);

    useEffect(() => {
        if (isLoggedIn) {
            getTradeInToggleVisibleConnect();
            getIsStraightThroughEligbleConnect();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if (isLoggedIn && (!isLoginFetchCarDetailCompleted || (appointmentId !== carId)) || tradeInToggleSelected) {
            fetchCarDetailsConnect(carId, { showS20GalleryVariant }).then(({ detail }) => {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.CAR_DETAIL, { ecomm_prodid: detail.appointmentId, ecomm_totalvalue: detail.egc });
            });
            updateLoginFetchCarDetailCompletedConnect(true);
        }
        if (carId && (!isSSR && ((similarCars || []).length === 0 || appointmentId !== carId || tradeInToggleSelected))) {
            fetchSimilarCarsConnect(carId, { size: 10, userFinanceType: FINANCE_TYPE.CARS24 });
        }
        if (isLoggedIn) {
            getWarrantyPlansConnect(`?appointmentId=${carId}`);
        }
        return (() => {
            updateLoginFetchCarDetailCompletedConnect(false);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn, tradeInToggleSelected, carId, appointmentId, isSSR]);

    useEffect(() => {
        if (!isLoggedIn) {
            getWarrantyPlansConnect(null, carId, NOT_LOGGED_IN);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoggedIn]);

    useEffect(() => {
        if (secureToken) {
            getTradeInDetailsConnect({ fromCdp: true });
        }
    }, [getTradeInDetailsConnect, secureToken]);

    useEffect(() => {
        trackDesktopCustomEventsAU(EVENT_DATA.PREMIUM_FEATURES_EXPOSURE, {
            ...EVENT_DATA.PREMIUM_FEATURES_EXPOSURE,
            eventLabel: desktopPremiumFeatures?.data
        });
        trackDesktopCustomEventsAU("comingSoonExperiment", {
            eventAction: "variant_assigned",
            event: "experiment",
            eventLabel: desktopComingSoon?.data || "no variant",
            eventCategory: "coming_soon_experiment"
        });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (sortingVariant) {
            trackDesktopCustomEventsAU(EVENT_DATA.CLASSIFIEDS_EXPOSURE, {
                ...EVENT_DATA.CLASSIFIEDS_EXPOSURE,
                eventAction: `desktop_variant_assigned_${currentStateCode}`,
                eventLabel: sortingVariant
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentStateCode, sortingVariant]);

    useEffect(() => {
        const { data: ewVariant = null } = desktopCdpEw || {};
        if (ewVariant !== null) {
            trackDesktopCustomEventsAU(EVENT_DATA.EW_ACTIVE_VARIANT, {
                ...EVENT_DATA.EW_ACTIVE_VARIANT,
                eventAction: "variant_assigned",
                eventLabel: ewVariant
            });
        }
        trackDesktopCustomEventsAU(EVENT_DATA.EW_ACTIVE_VARIANT_TRACKING, {
            ...EVENT_DATA.EW_ACTIVE_VARIANT_TRACKING,
            eventLabel: ewVariant || "no variant"
        });

    }, [desktopCdpEw]);

    const getOrder = useCallback(async () => {
        try {
            setIsFetchingOrderDetails(true);
            const response = await getOrderDetailConnect(carId);
            const stepResponse = await getCheckoutStepsConnect(response.orderId);
            setStep(stepResponse);
            if (stepResponse.step && stepResponse.nextStep) {
                setIsResumeVisible(true);
            }
        } catch (err) {
            // createOrderConnect()
        } finally {
            setIsFetchingOrderDetails(false);
        }
        // eslint-disable-next-line
    }, [carId, appointmentId]);

    // todo:deepak uncomment
    useEffect(() => {
        if (carId && secureToken && !carDetails.isFetching && carId === appointmentId) {
            getOrder();

        }
        // eslint-disable-next-line
    }, [carId, appointmentId, secureToken]);

    useEffect(() => {
        fetchLeadAppointmentConnect(appointmentId);
    }, [secureToken, appointmentId, fetchLeadAppointmentConnect]);

    useEffect(() => {
        if (personalised) {
            window.setTimeout(() =>
                setPreApprovalCoachMarkDisplayConnect(false),
            NUMBER.FIVE_THOUSAND
            );
        }
    }, [personalised, setPreApprovalCoachMarkDisplayConnect]);

    const wishlistSuccessCallback = (shortListed, showNotifyPopup) => {
        if (shortListed && showNotifyPopup) {
            setNotifyIconClicked(false);
            setWishlistActionCompleted(true);
            setCarReservationModal(true);
        }
    };

    const ecommerEventData = () => {
        const data = carListingEventDataParser(content, {
            list: CAR_LIST_EVENT_NAMES.DETAILS
        });
        return data;
    };

    const addItemToWishlist = (token, additionalProps = {}, gtmFrom = "") => {
        // const { access_token: token } = resp;
        const { addtoWishList } = ecommerEventData();
        trackDesktopCustomEventsAU(FB_EVENTS_CATEGORY.CDP_ADD_TO_WISHLIST, { content: addtoWishList });
        onClickAddToWishList(carId, token || secureToken, gtmFrom || "car_detail_page", { ...additionalProps, comingSoon, make, model, callback: wishlistSuccessCallback });
    };

    const onWishlistClick = (e, gtmFrom, showNotifyPopup = false) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (isLoggedIn) {
            addItemToWishlist("", { showNotifyPopup }, gtmFrom);
        } else {
            setLoginTypeConnect(LOGIN_TYPE.WISHLIST);
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.LOGIN_INITIATED, { eventLabel: LOGIN_SOURCE.WISHLIST });
            setOnLoginSuccessCallback((resp) => {
                const { access_token: token } = resp.profileResponse || resp;
                addItemToWishlist(token, { showNotifyPopup }, gtmFrom);
            });
            openLoginPopupConnect();
        }
    };

    const fireEwSkippedCTEvent = (deeplinkUrl = window.location.href) => {
        if (showEwVariantA) {
            return;
        }
        if (!ewDetails) {
            return;
        }
        if (isExtendedWarrantySelected) {
            return;
        }
        const extendedWarrantyProductName =  ewDetails?.name || ewDetails?.key;
        const extendedWarrantyProductPrice = ewDetails?.ewPrice;
        const queryParams = qs.parse(query);
        const name = fullName || `${firstName} ${lastName}`;
        const finalEmail = email || userEmail;
        const cleverTapData = {
            [EW_NOT_ADDED_KEYS.CAR_NAME]: `${year} ${make} ${model}`,
            [EW_NOT_ADDED_KEYS.CAR_HUB]: state,
            [EW_NOT_ADDED_KEYS.ENTRY_POINT]: EW_SKIPPED_ENTRY_POINTS.CDP,
            [EW_NOT_ADDED_KEYS.USER_NAME]: name,
            [extendedWarrantyProductName]: extendedWarrantyProductPrice,
            [EW_NOT_ADDED_KEYS.EW_CATEGORY]: category,
            [EW_NOT_ADDED_KEYS.USER_EMAIL]: finalEmail,
            [EW_NOT_ADDED_KEYS.UTM_SOURCE]: queryParams?.utm_source,
            [EW_NOT_ADDED_KEYS.UTM_MEDIUM]: queryParams?.utm_medium,
            [EW_NOT_ADDED_KEYS.UTM_CAMPAIGN]: queryParams?.utm_campaign,
            [EW_NOT_ADDED_KEYS.DEEP_LINK_URL]: deeplinkUrl
        };
        ewSkippedCTEvent(cleverTapData);
    };

    const trackEvent = (type, label, ctaSource = null) => {
        switch (type) {
        case AU_DESKTOP_EVENTS.CAR_DETAILS_ATF_INTERACTIONS:
            label = "selected get_started";
            trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.BOOKING_INITIATED, {
                ecomm_prodid: appointmentId,
                ecomm_totalvalue: egc
            });
            break;
        case AU_DESKTOP_EVENTS.CAR_DETAILS_PRICE_BREAK_DOWN_GET_STARTED:
            break;
        case AU_DESKTOP_EVENTS.START_PURCHASE:
            break;
        case AU_DESKTOP_EVENTS.CAR_GALLERY_VIEW:
            break;
        case AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_GET_STARTED:
            label = ctaSource;
            break;
        case AU_DESKTOP_EVENTS.BUY_ONLINE_CTA_CLICKED:
            break;
        default: type = "";
        }
        if (type) { trackDesktopCustomEventsAU(type, { eventLabel: label }); }
    };

    const updateOrderForBuyNow = (data, e, ctaSource = null) => {
        window.console.log("[DEBUG] updateOrderForBuyNow called — navigating to checkout");
        const payload = {
            orderType: ORDER_TYPE.BUY_ONLINE,
            ...ewRequestPayload
        };
        const deeplinkUrl = window.location.href;

        if (orderId) {
            updateOrderConnect(orderId, payload, ewRequestBody).then(() => {
                const { relativeURL } = getCheckoutPageURL(content, CHECKOUT_ROUTE_PATHS.deliveryDetails);
                history.push(relativeURL);
            });
        } else {
            const { relativeURL } = getCheckoutPageURL(content, CHECKOUT_ROUTE_PATHS.deliveryDetails);
            history.push(relativeURL);
        }
        updateValidC2bOrderConnect(secureToken);

        if (ctaSource) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventLabel: ctaSource
            });
        } else {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, {
                eventAction: "cta_selected",
                eventLabel: "buy_online"
            });
        }
        fireEwSkippedCTEvent(deeplinkUrl);
    };

    const onGetStartedClick = (event, e, ctaSource = null) => {
        trackEvent(event, "selected get_started", ctaSource);
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.ZERO_DP_CDP, {
            eventLabel: isUserZeroDpVariant ? "Clicked_Variant B" : "Clicked_Variant A"
        });

        if (EXPERIMENT_TYPE.VARIANT_B) {
            trackDesktopCustomEventsAU(EVENT_DATA.CTA_OPTIMIZATION);
        }

        pendingActionRef.current = () => updateOrderForBuyNow();
        loginGate.trigger();
        if (!isLoggedIn) {
            trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CARS24_DETAIL_PAGE, { eventAction: "sign_up", eventLabel: "sign_up_screen_shown" });
        }

        trackDesktopCustomEventsAU(EVENT_CONSTANTS.CHECKOUT_INITIATED, EVENT_DATA.CHECKOUT_INITIATED);
    };

    const rioProps = {
        threshold: 0,
        rootMargin: "-144px 0px 0px 0px"
    };

    const getDealershipCta = () => {
        if (isLoggedIn && carDetails?.leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) {
            return "View Dealer";
        }
        return "Contact dealer";
    };
    const hasOrderForComingSoonCar = comingSoon && Boolean(orderId) && Boolean(orderCustomerPhoneNumber);

    const isPreviousSectionInView = (arr, index) => {
        for (let i = 0; i < index; i++) {
            if (arr[i].inView) {
                return true;
            }
        }
        return false;
    };
    const [premiumFeaturesRef, premiumFeaturesRefInView, premiumFeaturesEntry] = useInView(rioProps);
    const [featuresAndSpecsRef, featuresAndSpecsRefInView, featuresAndSpecsRefEntry] = useInView(rioProps);
    const [qualityPromiseRef, qualityPromiseRefInView, qualityPromiseRefEntry] = useInView(rioProps);
    const [carhistoryRef, carhistoryRefInView, carhistoryRefEntry] = useInView(rioProps);
    // eslint-disable-next-line no-unused-vars
    const [loanCalculatorRef, loanCalculatorRefInView, loanCalculatorRefEntry] = useInView(rioProps);

    const menuItems = [
        { label: "Premium Features", inView: premiumFeaturesRefInView, entry: premiumFeaturesEntry, gtmLabel: "premium_features", isVisible: isInternalListing },
        { label: "Feature and Specs", inView: featuresAndSpecsRefInView, entry: featuresAndSpecsRefEntry, gtmLabel: "feature_and_specifications", isVisible: true },
        { label: "Car History", inView: carhistoryRefInView, entry: carhistoryRefEntry, gtmLabel: "car_history", isVisible: true },
        { label: "Car imperfections", inView: qualityPromiseRefInView, entry: qualityPromiseRefEntry, gtmLabel: "quality_promise", isVisible: isInternalListing },
        { label: "Loan Calculator", inView: loanCalculatorRefInView, entry: loanCalculatorRefEntry, gtmLabel: "loan_calculator", isVisible: false }
    ].filter(Boolean)
        .map((item, index, arr) => {
            return {
                ...item,
                inView: isPreviousSectionInView(arr, index) ? false : item.inView
            };
        });

    const onChangeInView = (inView) => {
        const isVisible = !inView;
        // eslint-disable-next-line no-magic-numbers
        setIsStickyHeaderVisible(isVisible ? isVisible && window.scrollY > 75 : isVisible);
    };

    const onTop = () => {
        setIsStickyHeaderVisible(false);
    };

    const handleCarReservationModal = () => {
        setCarReservationModal(!carReservationModalOpen);
        if (!carReservationModalOpen) {
            setWishlistActionCompleted(false);
            setNotifyIconClicked(false);
        }
    };

    const onClickNotifyIcon = () => {
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME_TOOLTIP);
        setNotifyIconClicked(true);
        setCarReservationModal(true);
    };

    const onResumeRedirect = async () => {
        const deeplinkUrl = window.location.href;
        if (isLoggedIn) {
            let routeStep = "";
            if (step.nextStep === CHECKOUT_STEPS.TRADEIN && !showTradeInCheckoutStep) {
                routeStep = (servicingPriceConfig?.pill !== null) ? CHECKOUT_STEPS.CARCOVER : CHECKOUT_STEPS.ADDONS;
            } else {
                routeStep = step.nextStep;
            }

            await updateOrderConnect(orderId, ewRequestPayload, ewRequestBody);
            const {relativeURL} = getCheckoutPageURL({make, model, appointmentId}, CHECKOUT_ROUTE_PATHS[CHECKOUT_STEPS_PATH[routeStep]]);
            updateValidC2bOrderConnect(secureToken);
            history.push(relativeURL);
        } else {
            openLoginPopupConnect();
            setOnLoginSuccessCallback(() => {
                const { relativeURL } = getCheckoutPageURL({ make, model, appointmentId }, CHECKOUT_ROUTE_PATHS[CHECKOUT_STEPS_PATH[step.nextStep]]);
                history.push(relativeURL);
            });
        }
        fireEwSkippedCTEvent(deeplinkUrl);
    };

    const { isFirstUserSession } = usePreBiAssistance();
    const { fireNudge } = useFireNudge({
        updateSupportWidgetConfig: updateSupportWidgetConfigConnect,
        updateNudgeCounts: updateNudgeCountsConnect,
        updateNotificationCounts: updateNotificationCountsConnect,
        setNudgeTimerId: setNudgeTimerIdConnect,
        make,
        model
    });

    const handleSupportNudge = (nudgeConfig) => {
        if (!categoryNudgeCounts[nudgeConfig.category] && nudgeCountSynced) {
            fireNudge(nudgeConfig);
        }
    };

    const handleImpressionView = () => {
        if (isFirstUserSession) {
            handleSupportNudge(PRE_BI_ASSISTANCE_CONFIG.newUser.CDP.SCROLL_PAST_INSPECTION_REPORT);
        }

    };

    const handleShowLoggedInDealerRedirect = (redirectRoute, source = "") => {
        setDealerRedirectRoute(redirectRoute);
        setClassifiedModalSource(source);
        setShowLoggedInDealerRedirectModal(true);
    };

    const handleViewDealerFromModal = () => {
        setShowLoggedInDealerRedirectModal(false);
        if (dealerRedirectRoute) {
            history.push(dealerRedirectRoute);
        }
    };

    const proceedWithClassifiedLead = (dealerRoute) => {
        trackDesktopCustomEventsAU(GA_EVENTS.CLASSIFIED_LEAD_INITIATED, {
            ...GA_EVENTS.CLASSIFIED_LEAD_INITIATED,
            eventLabel: "Checkout"
        });
        createClassifiedLeadConnect().then((leadResponse) => {
            trackDesktopCustomEventsAU(GA_EVENTS.CLASSIFIED_LEAD_COMPLETED, {
                ...GA_EVENTS.CLASSIFIED_LEAD_COMPLETED,
                eventLabel: leadResponse?.leadCode || null
            });
        });
        handleShowLoggedInDealerRedirect(dealerRoute, "Checkout");
    };

    const handleClassified = () => {
        const dealerName = dealerInfo?.[dealerCode]?.name || "";
        const dealerRoute = getDealerPage(dealerName, dealerCode);

        // Already confirmed lead - just redirect
        if (isLoggedIn && carDetails?.leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) {
            history.push(dealerRoute);
            return;
        }

        pendingActionRef.current = () => proceedWithClassifiedLead(dealerRoute);
        loginGate.trigger();
    };

    const handleComingSoonEnquire = () => {
        comingSoonGate.trigger();
    };

    const getCta = () => {
        let text = "Get started";
        let action = onGetStartedClick;
        let disabled = false;
        let iconType = "Wishlist";
        let transparentButton = false;
        let key = "";
        if (isResumeVisible && isLoggedIn) {
            text = "Continue buying";
            action = onResumeRedirect;
            disabled = false;
        }
        if (isTestDriveEnabledState({ state, userState, eligibleStateNames })) {
            text = "Get started";
        }
        if (postOrderBookingConfirmed(orderStatus)) {
            text = "Track order";
            disabled = false;
            action = (data, e, ctaSource = null) => {
                const { relativeURL: viewTaskUrl } = getMyBookingCarDetailsURL(
                    content.appointmentId,
                    enableNewPostBook ? TASKS_ROUTE_PATHS.driverLicence : TASKS_ROUTE_PATHS.viewTask,
                    null,
                    null
                );
                if (ctaSource) {
                    trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_TRACK_ORDER, {
                        eventLabel: ctaSource
                    });
                }
                history.push(viewTaskUrl);
            };
        } else if (booked || !listingActive) {
            text = "SOLD";
            disabled = true;
            action = () => { };
        } else if (reserved) {
            if (orderStatus === ORDER_STATUS.TEST_DRIVE_RESERVED) {
                text = "Get started";
                disabled = false;
                iconType = null;
                action = updateOrderForBuyNow;
            } else if (isWishlistedCar(carId)) {
                text = "Remove from wishlist";
                disabled = false;
                iconType = null;
                key = "removedReservationNofication";
                action = (data, e, ctaSource = null) => {
                    const deeplinkUrl = window.location.href;
                    handleCarReservationModal();
                    if (ctaSource) {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_REMOVE_FROM_WISHLIST, {
                            eventLabel: ctaSource
                        });
                    } else {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_REMOVE_FROM_WISHLIST, {
                            eventLabel: "reserved"
                        });
                    }
                    fireEwSkippedCTEvent(deeplinkUrl);
                };
                transparentButton = true;
            } else {
                text = "Notify if available";
                disabled = false;
                iconType = "Info";
                key = "addReservationNotification";
                action = (data, e, ctaSource = null) => {
                    const showNotifyPopup = true;
                    onWishlistClick(e, "", showNotifyPopup);
                    if (ctaSource) {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_COMPARE_NOTIFY_IF_AVAILABLE, {
                            eventLabel: ctaSource
                        });
                    } else {
                        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.RESERVATION_NOTIFY_ME_CTA);
                    }
                    const detailsData = clevertapDetails(content, { prefix: "notify_", config });
                    desktopCleverTapEvent(CLEVERTAP_EVENT_MAP.NOTIFY_ME, detailsData);
                    // handleCarReservationModal();
                };
            }
        } else if (comingSoon) {
            text = "Enquire now";
            disabled = hasOrderForComingSoonCar;
            iconType = null;
            action = handleComingSoonEnquire;
            key = "comingSoon";
        }
        if (testDriveStatus === ORDER_STATUS.TEST_DRIVE_COMPLETED) {
            text = "Continue buying";
        }
        if (isDealerListing && listingActive && !comingSoon) {
            text = getDealershipCta();
            disabled = false;
            action = handleClassified;
            transparentButton = false;
        }

        return { text, action, disabled, iconType, transparentButton, key };
    };

    const handleKbbModal = (type, value) => {
        setShowKbbModal({ ...showKbbModal, [type]: value });
    };

    const closeModal = (type, value) => {
        showSiteControlWidget(SITE_CONTROL_EVENTS.SHOW_ON_KBB_CLOSE);
        handleKbbModal(type, value);
    };
    const cta = getCta();
    // const isSaleOn = true;

    const scrollToSection = (ref) => {
        if (ref) {
            trackDesktopCustomEventsAU(EVENT_CONSTANTS.LOAN_CALCULATOR_CDP_ACTION, EVENT_DATA.LOAN_CALCULATOR_CDP_ACTION);

            // eslint-disable-next-line no-unused-expressions
            ref.current && ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }
    };

    // const onTradeInBannerClick = () => {
    //     if (tradeInRef) { tradeInRef.current.scrollIntoView({ behavior: "smooth", block: "center" }); }
    //     trackDesktopCustomEventsAU(EVENT_CONSTANTS.TRADE_IN_BANNER_ACTION, EVENT_DATA.TRADE_IN_BANNER_ACTION);
    // };

    useEffect(() => {
        if (appointmentId === carId) {
            // stores the repeat appId to fire a nudge just once, stops storing Ids after nudge is fired
            let repeatAppIdNudge = getItem(LOCAL_STORAGE_KEYS.seenAppointmentIds);

            if (repeatAppIdNudge) {
                // check if appointmentid exists and it's set to false, meaning repeated user
                if (repeatAppIdNudge.hasOwnProperty(appointmentId) && !repeatAppIdNudge[appointmentId]) {
                    const updatedseenAppointmentIds = {...repeatAppIdNudge, [appointmentId]: true, seenTooltip: true};
                    setItem(updatedseenAppointmentIds, LOCAL_STORAGE_KEYS.seenAppointmentIds);

                } else if (!repeatAppIdNudge.hasOwnProperty(appointmentId)) {
                    const updatedseenAppointmentIds = {...repeatAppIdNudge, [appointmentId]: false};
                    setItem(updatedseenAppointmentIds, LOCAL_STORAGE_KEYS.seenAppointmentIds);
                }
            } else {
                repeatAppIdNudge = {[appointmentId]: false, seenTooltip: false};
                setItem(repeatAppIdNudge, LOCAL_STORAGE_KEYS.seenAppointmentIds);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId]);
    useEffect(() => {

        if (appointmentId) {
            const recentlyViewedCount = getCookie(AU_RECENTLY_VIEWD_COUNT);
            const parsedRecentlyViewedCount = recentlyViewedCount ? JSON.parse(recentlyViewedCount) : {};

            if (parsedRecentlyViewedCount[appointmentId]) {
                parsedRecentlyViewedCount[appointmentId]++;
            } else {
                parsedRecentlyViewedCount[appointmentId] = 1;
            }
            saveCookie(AU_RECENTLY_VIEWD_COUNT, JSON.stringify(parsedRecentlyViewedCount), NUMBER.THREE_HUNDRED_SIXTY_FIVE);
            setCarSeenCountConnect(parsedRecentlyViewedCount[appointmentId]);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appointmentId]);

    useEffect(() => {
        if (!isSSR && appointmentId !== carId) {
            fetchCarDetailsConnect(carId, {showS20GalleryVariant}).then(({detail}) => {
                trackCustomReMarketingEvents(MARKETING_EVENTS_CONSTANTS.CAR_DETAIL, {ecomm_prodid: detail.appointmentId, ecomm_totalvalue: detail.egc });
            });
        } else {
            updateCarDetailsSSRStatusConnect(false);
        }
        addToRecentlyViewed(AU_RECENTLY_VIEWD_KEY, carId);
        // if (carId) {  fetchSimilarCarsConnect(carId, { size: 20 }); }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [carId]);

    useEffect(() => {
        if (shouldReloadCarDetails) {
            fetchCarDetailsConnect(carId);
            fetchCmsConfigConnect({
                slug: isDealerListing ? CMS_SLUG_CONSTANTS.CAR_DETAILS_DESKTOP_DEALER : CMS_SLUG_CONSTANTS.CAR_DETAILS_DESKTOP,
                appointmentId: carId,
                pincode: userGeoData?.postalCode
            });
            reloadCarDetailsConnect(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldReloadCarDetails]);

    const aboutThisCarTitleStyle = (isWebCarTourVariant && carTourPresent) ? "styles.aboutThisCarTitleVideoGallery" : "styles.aboutThisCarTitle";

    // Extract CMS config for CDP card ordering
    const pageSection = getCdpPageSection(cmsConfig, isInternalListing);
    const cdpConfig = parseCdpConfig(pageSection);
    // Build render context for CMS-driven card rendering
    const renderContext = {
        // Listing type
        isInternalListing,
        isDealerListing,

        // Content and config
        content,
        config,
        buyWithConfidence,

        // Handlers and refs
        handleFeatureSpecsModal,
        handleCarPriceGuideCardModal,
        getDeliveryInfoConnect,
        setDeliveryTimelineConnect,
        handleImpressionView,

        // Refs
        premiumFeaturesRef,
        featuresAndSpecsRef,
        carhistoryRef,
        qualityPromiseRef,
        calculatorRef,

        // Styles and variants
        aboutThisCarTitleStyle,
        deliveryTimelineVariant,

        // Conditional sections
        chrMediumBannerSection,
        financeCardSection,

        // Car price guide props
        showKBB,
        priceScale,
        egc,
        dealerComment,
        handleShowLoggedInDealerRedirect,
        isLuxuryCar,
        isLuxuryCarVariant,
        cmsConfig
    };

    // Calculate visible cards from CMS config
    const visibleCards = calculateCdpCardOrder(cdpConfig || (isInternalListing ? DESKTOP_CAR_DETAILS_ORDERING : DESKTOP_CAR_DETAILS_ORDERING_DEALER), renderContext);
    const isPriceGuideCmsVisible = visibleCards.some(c => c.key === CDP_CARD_KEYS.CAR_PRICE_GUIDE);

    // eslint-disable-next-line no-nested-ternary
    return !isFetching && content && !error ? (
        <React.Fragment>
            <MetaTagsCarDetailsV2 config={config} carDetails={content} cityName={COUNTRY.name} countryCode="au" />
            <InView rootMargin={"10px 0px 10px 0px"} as="div" onChange={onTop} />
            <div styleName={`styles.${isStickyHeaderVisible ? "visible" : "hidden"}`}>
                <CarDetailStickyViewRevamp
                    ctaProps={cta}
                    comingSoon={comingSoon}
                    onWishlistClick={onWishlistClick}
                    isWishlisted={isWishlistedCar(carId)}
                    onClickNotifyIcon={onClickNotifyIcon}
                    menuItems={menuItems}
                    showCta={showCta}
                    isCdpCtaReorderVariant={isCdpCtaReorderVariant}
                    comingSoonExperiment={desktopComingSoon}
                />

            </div>

            <InView rootMargin={"150px 0px 0px 0px"} as="div" onChange={onChangeInView} />
            <div className="container" styleName={"styles.outerContainer"}>

                <div styleName={"styles.leftColumnWrapper"}>
                    <div>
                        <CarDetailAtfVariantRevamp
                            onWishlistClick={onWishlistClick}
                            isWishlisted={isWishlistedCar(carId)}
                            ctaProps={cta}
                            comingSoon={comingSoon}
                            handleKbbModal={handleKbbModal}
                            // isSaleOn={isSaleOn}
                            isFetchingOrderDetails={isFetchingOrderDetails}
                            isKbbShown={!!showKBB}
                            onClickNotifyIcon={onClickNotifyIcon}
                            isStickyHeaderVisible={isStickyHeaderVisible}
                            content={content}
                            calculatorRef={calculatorRef}
                            scrollToSection={scrollToSection}
                            step={step}
                            comingSoonExperiment={desktopComingSoon}
                        />
                    </div>

                    <TrackImpression event={{
                        properties: {
                            "Card_viewed": "Finance_CDP"
                        },
                        gaName: EVENT_CONSTANTS.CARD_VIEWED,
                        data: EVENT_DATA.CARD_VIEWED
                    }}>
                        {/* <CdPFirstFoldBottomBannerRevamp onTradeInBannerClick={onTradeInBannerClick} /> */}
                    </TrackImpression>

                    {/* CMS-driven card rendering */}
                    {visibleCards.length > 0 ? (
                        visibleCards.map(card => renderCdpCardByKey(card, renderContext))
                    ) : null}

                    {/* <div styleName={"styles.testimonialWrapper"}>
                        <TrackImpression event={{}} wrapWithDiv={false}>
                            <HappyPurchase showTitle={false} source={PAGE_SOURCE.CDP} />
                        </TrackImpression>
                    </div> */}
                </div>
                <div styleName={`styles.rightColumnWrapper ${ewStickyTopClass}`}>
                    <CarDetailsCardRevamp
                        content={content}
                        ctaProps={cta}
                        comingSoon={comingSoon}
                        calculatorRef={calculatorRef}
                        scrollToSection={scrollToSection}
                        onWishlistClick={onWishlistClick}
                        isWishlisted={isWishlistedCar(carId)}
                        onClickNotifyIcon={onClickNotifyIcon}
                        isFetchingOrderDetails={isFetchingOrderDetails}
                        isCdpCtaReorderVariant={isCdpCtaReorderVariant}
                        comingSoonExperiment={desktopComingSoon}
                    />
                    <div styleName={"styles.locationDetailsCard"}>
                        <CarLocationDetails handleShowLoggedInDealerRedirect={handleShowLoggedInDealerRedirect} />
                    </div>
                    {comingSoon ? <div styleName={"styles.comingSoonAvailabilityCard"}>
                        <ComingSoonAvailabilityCard cmsSections={pageSections} />
                    </div> : null}
                    {(showKBB && isPriceGuideCmsVisible && !cmsConfig?.isFetching && !carDetails?.isFetching)  ? <div styleName={"styles.priceGuideCard"}>
                        <CarPriceGuideCard priceScale={priceScale}
                            egc={egc}
                            handleCarPriceGuideCardModal={handleCarPriceGuideCardModal}
                        />
                    </div> : null}
                </div>
            </div>

            <div className="container">
                {(similarCars || []).length ?
                    <div styleName="styles.keyHighlight">
                        <TrackImpression event={{}} wrapWithDiv={false}>
                            <MoreCarsRevamp isCdpRevamp={true} config={config} carList={similarCars} title={"Similar cars for you"} isMoreCars={true} sourceAppointmentId={appointmentId} />
                        </TrackImpression>
                    </div> : null}
                <InView rootMargin={"700px 0px -150px 0px"} as="div" onChange={setShowCtaHandler} />
                {similarModelCars.length ?
                    <div styleName="styles.keyHighlight">
                        <TrackImpression event={{}} wrapWithDiv={false}>
                            <MoreCarsRevamp isCdpRevamp={true} config={config} carList={similarModelCars || []} title={`More ${`${make} ${model}`} cars for you`} isMoreCars={false} sourceAppointmentId={appointmentId} />
                        </TrackImpression>
                    </div> : null}

                <TrackImpression event={{ name: "moreCarsForYouViewed", data: { "platform": WEB_SOURCE.desktop } }}>
                    <div styleName="styles.keyHighlight">
                        <MoreCarsForYouRevamp isCdpRevamp={true} />
                    </div>
                </TrackImpression>
                {faqData.length > 0 && <TrackImpression event={{ name: "faqViewd" }} styleName="styles.keyHighlight">
                    <CarDetailsFaq faqCdpRevamp={true}
                        faqData={faqData}
                        // faqRef={faqRef}
                    />
                </TrackImpression>}
            </div>

            {!hideSiteHeader && <ErrorHandler>
                <CDPBreadCrumb />
            </ErrorHandler>
            }
            {showKbbModal.detail &&
                <KelleyBlueBookPopup
                    onClose={() => closeModal("detail", false)}
                    carEgcPrice={egc}
                    vehicleRetailPriceRangeMin={vehicleRetailPriceRangeMin}
                    vehicleRetailPriceRangeMax={vehicleRetailPriceRangeMax}
                    kbbValueProvidedOn={kbbValueProvidedOn}
                />}
            {/* {showKbbModal.approach &&
                <CarPricingApproachPopup
                    onClose={() => closeModal("approach", false)}
                /> } */}
            {
                carReservationModalOpen &&
                <CarReservationNotifyModal
                    isOpen={carReservationModalOpen}
                    notifyIconCliked={notifyIconCliked}
                    onClickNotifyIcon={onClickNotifyIcon}
                    cta={cta}
                    reserved={reserved}
                    isWishlistedCar={isWishlistedCar(carId)}
                    onWishlistClick={onWishlistClick}
                    wishlistActionCompleted={wishlistActionCompleted}
                    handleCarReservationModal={handleCarReservationModal}
                />
            }
            {/* {showPreApprovalCoachmark &&  <CoachMark showCoachMark={showPreApprovalCoachmark}/>} */}
            <div styleName={"styles.goToTopContainer"}>
                <CdpGoToTop />
            </div>
            {
                showPersonaliseYourWishlistModal &&
                    <PersonaliseYourWishlistModal
                        isOpen={showPersonaliseYourWishlistModal}
                        personalizationSectionData={personalizationSectionData}
                        trackEvent={trackDesktopCustomEventsAU}
                        carId={carId}
                        updateWishlistNoteConnect={updateWishlistNoteConnect}
                        showPrioritizationModalConnect={showPrioritizationModalConnect}
                        pageSource={PAGE_SOURCE.CDP}
                    />
            }
            <FeatureSpecificationModal
                isOpen={isFeatureSpecsModalOpen}
                onClose={handleFeatureSpecsModal}
                content={content}
                featuresAndSpecsRef={featuresAndSpecsRef}
                handleFeatureSpecsModal={handleFeatureSpecsModal}
            />
            <CarPriceGuideCardModal
                isOpen={isCarPriceGuideCardModalOpen} onClose={handleCarPriceGuideCardModal}
                priceScale={priceScale}
                egc={egc}/>
            {
                showLoggedInDealerRedirectModal && <LoggedInDealerRedirectModal
                    isOpen={showLoggedInDealerRedirectModal}
                    handleOnClose={() => setShowLoggedInDealerRedirectModal(false)}
                    dealerName={dealerInfo?.[dealerCode]?.name || ""}
                    onViewDealer={handleViewDealerFromModal}
                    source={classifiedModalSource}
                    cmsConfig={rootCmsConfig}
                />
            }
            {showComingSoonThank && (
                <CommingSoonThankModal
                    title={`${year} ${make} ${model}`}
                    onClose={() => setShowComingSoonThank(false)}
                />
            )}
        </React.Fragment>
    ) : (
        error ? <PageNotFoundRevamp /> : <Skeleton />
    );
};

CarDetailsRevamp.propTypes = {
    match: PropTypes.object,
    carDetails: PropTypes.object,
    fetchCarDetailsConnect: PropTypes.func,
    updateCarDetailsSSRStatusConnect: PropTypes.func,
    setGsGalleryDataConnect: PropTypes.func,
    clearAllFiltersConnect: PropTypes.func,
    fetchSimilarCarsConnect: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    getDeliveryInfoConnect: PropTypes.func,
    setOnLoginSuccessCallback: PropTypes.func,
    openLoginPopupConnect: PropTypes.func,
    reloadCarListConnect: PropTypes.func,
    history: PropTypes.object,
    selectedCity: PropTypes.object,
    similarCars: PropTypes.object,
    orderStatus: PropTypes.string,
    onClickAddToWishList: PropTypes.func,
    secureToken: PropTypes.string,
    appliedDeliveryPincode: PropTypes.number,
    isWishlistedCar: PropTypes.func,
    getOrderDetailConnect: PropTypes.func,
    updateLoginFetchCarDetailCompletedConnect: PropTypes.func,
    splitPaymentOpted: PropTypes.bool,
    showFullScreenGallery: PropTypes.bool,
    isUserZeroDpVariant: PropTypes.bool,
    fetchConfigConnect: PropTypes.func,
    saleConfig: PropTypes.func,
    fetchEgcPriceConnect: PropTypes.func,
    createOrderConnect: PropTypes.func,
    updateBasicHubspotConnect: PropTypes.func,
    mobile: PropTypes.string,
    updateOrderConnect: PropTypes.func,
    orderId: PropTypes.string,
    getCheckoutStepsConnect: PropTypes.func,
    getInhouseEligibilityConnect: PropTypes.func,
    showInHouseFinance: PropTypes.string,
    inHouseFinanceEligibility: PropTypes.bool,
    getTradeInToggleVisibleConnect: PropTypes.func,
    tradeInToggleSelected: PropTypes.bool,
    getWarrantyPlansConnect: PropTypes.func,
    showPreApprovalCoachmark: PropTypes.bool,
    setPreApprovalCoachMarkDisplayConnect: PropTypes.func,
    showPremiumFeatures: PropTypes.object,
    setDeliveryTimelineConnect: PropTypes.func,
    showUserDeliveryTimeline: PropTypes.object,
    financeProvider: PropTypes.string,
    email: PropTypes.string,
    appliedFilters: PropTypes.object,
    allFilters: PropTypes.object,
    selectedSort: PropTypes.object,
    listingType: PropTypes.string,
    getZeroDpConfigConnect: PropTypes.func,
    showCdpGalleryVariant: PropTypes.object,
    hideSiteHeader: PropTypes.bool,
    cdpBiCta: PropTypes.object,
    testDriveStatus: PropTypes.bool,
    setLoginTypeConnect: PropTypes.func,
    getInhousePreApprovalLoanDetailsConnect: PropTypes.func,
    getIsStraightThroughEligbleConnect: PropTypes.func,
    buyWithConfidence: PropTypes.func,
    getInterestRateForPriceCalculatorConnect: PropTypes.func,
    userGeoData: PropTypes.object,
    updateValidC2bOrderConnect: PropTypes.func,
    gaId: PropTypes.string,
    showEmailSupportModal: PropTypes.bool,
    getTradeInDetailsConnect: PropTypes.func,
    drivingLicenceStatus: PropTypes.bool,
    testDriveConfig: PropTypes.object,
    fetchCmsConfigConnect: PropTypes.func,
    updateWishlistNoteConnect: PropTypes.func,
    showPrioritizationModalConnect: PropTypes.func,
    showPersonaliseYourWishlistModal: PropTypes.bool,
    desktopWishlistAdoption: PropTypes.object,
    categoryNudgeCounts: PropTypes.object,
    updateSupportWidgetConfigConnect: PropTypes.func,
    updateNudgeCountsConnect: PropTypes.func,
    updateNotificationCountsConnect: PropTypes.func,
    setNudgeTimerIdConnect: PropTypes.func,
    nudgeCountSynced: PropTypes.bool,
    servicingPriceConfig: PropTypes.object,
    desktopCdpEw: PropTypes.object,
    desktopPremiumFeatures: PropTypes.object,
    setCarSeenCountConnect: PropTypes.func,
    paymentSummaryData: PropTypes.object,
    fullName: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    userEmail: PropTypes.string,
    webCarTour: PropTypes.object,
    phoneNumberVerified: PropTypes.bool,
    orderCustomerPhoneNumber: PropTypes.string,
    cdpCtaReorder: PropTypes.object,
    fetchLeadAppointmentConnect: PropTypes.func,
    createClassifiedLeadConnect: PropTypes.func,
    dealerInfo: PropTypes.object,
    dealerSSR: PropTypes.bool,
    shouldReloadCarDetails: PropTypes.bool,
    getDealerInfoConnect: PropTypes.func,
    reloadCarDetailsConnect: PropTypes.func,
    desktopLuxuryCars: PropTypes.bool,
    hideImperfectionsDesktop: PropTypes.object,
    desktopVehicleBasePrice: PropTypes.object,
    desktopComingSoon: PropTypes.object,
    rootCmsConfig: PropTypes.object
};

export default CarDetailsRevamp;
